import { type YakurekiDetail } from '@/shared/types/yakurekiCore'

// 文字起こしからの再生成ボタンの判定 (純関数・テスト対象)。back の受け口
// (services/regenerate/from_dictated.py) と同じ順・同じ文言で弾く。会話も資料も無い記録は
// back が 400 で返す (front は資料の件数を持たないので、ここでは見ない)。

export const MAX_REGENERATE = 3

// 話者分離版がもうすぐ来る間 (= running、または音声を保存済みで走る直前の pending) だけ待つ。
// それ以外 (来る予定が無い・失敗した) は、今入っている文字起こし (ライブ版) で作り直せる。
const postBatchIsComing = (event: YakurekiDetail): boolean => {
  const postBatchStatus = event.transcription?.post_batch_status
  if (postBatchStatus === 'running') return true
  return postBatchStatus === 'pending' && Boolean(event.audio?.audio)
}

export const regenerateGate = (
  event: YakurekiDetail
): { canRegenerate: boolean; tooltip: string } => {
  const regenerateCount = event.regenerate_count ?? 0
  if (event.status === 'processing')
    return {
      canRegenerate: false,
      tooltip: 'SOAP を生成中のため再生成できません',
    }
  if (regenerateCount >= MAX_REGENERATE)
    return {
      canRegenerate: false,
      tooltip: `再生成回数の上限 (${MAX_REGENERATE} 回) に達しました`,
    }
  if (postBatchIsComing(event))
    return {
      canRegenerate: false,
      tooltip: '話者分離の処理中のため、終わってから再生成してください',
    }
  return {
    canRegenerate: true,
    tooltip: `再生成 (残り ${MAX_REGENERATE - regenerateCount} 回)`,
  }
}
